import React from 'react';
import { Music2, Activity } from 'lucide-react';
import { motion } from 'framer-motion';

interface AppIconProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  animated?: boolean;
}

export const AppIcon: React.FC<AppIconProps> = ({ 
  className = "", 
  size = 'md',
  animated = true 
}) => {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  const IconWrapper = animated ? motion.div : 'div';

  return (
    <div className={`relative ${sizes[size]} ${className}`}>
      <IconWrapper
        className="absolute inset-0"
        initial={animated ? { rotate: -10, scale: 0.9 } : undefined}
        animate={animated ? { rotate: 0, scale: 1 } : undefined}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      >
        <div className="w-full h-full rounded-2xl bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 flex items-center justify-center transform rotate-12">
          <Music2 className="w-2/3 h-2/3 text-white" />
        </div>
      </IconWrapper>
      <IconWrapper
        className="absolute inset-0"
        initial={animated ? { rotate: 10, scale: 0.9 } : undefined}
        animate={animated ? { rotate: 0, scale: 1 } : undefined}
        transition={{ type: "spring", stiffness: 300, damping: 20, delay: 0.1 }}
      >
        <div className="w-full h-full rounded-2xl bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-500 flex items-center justify-center transform -rotate-12 opacity-75">
          <Activity className="w-2/3 h-2/3 text-white" />
        </div>
      </IconWrapper>
    </div>
  );
};